import InnerTabs from './InnerTabs';

export default InnerTabs;
